import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("rule-header", {
        class: {
          "expanded-top": _vm.isExpanded(_vm.rulesetType, _vm.ruleIndex),
        },
        attrs: {
          rule: _vm.mutableRule,
          "product-counts": _vm.productCounts || [],
          expanded: _vm.isExpanded(_vm.rulesetType, _vm.ruleIndex),
          disabled: _vm.disabled,
        },
        on: {
          expand: function ($event) {
            return _vm.toggleExpanded(_vm.rulesetType, _vm.ruleIndex)
          },
          deleteRule: _vm.deleteRule,
          copyRule: _vm.handleCopyRule,
          updateDescription: _vm.updateDescription,
        },
      }),
      _vm._v(" "),
      _c(
        VExpandTransition,
        [
          _vm.isExpanded(_vm.rulesetType, _vm.ruleIndex)
            ? _c(
                VFlex,
                { attrs: { grow: "" } },
                [
                  _c(
                    VCard,
                    {
                      staticClass: "rule-card expanded-bottom",
                      class: {
                        "elevation-6": !_vm.isExpanded(
                          _vm.rulesetType,
                          _vm.ruleIndex
                        ),
                      },
                      attrs: { outlined: "" },
                    },
                    [
                      _c(
                        VCard,
                        { staticClass: "rule-content", attrs: { flat: "" } },
                        [
                          _c("attribute-filter-panel", {
                            attrs: {
                              "ruleset-type": _vm.rulesetType,
                              "filter-rules": _vm.mutableRule.scope,
                              "enable-non-attribute-filters": false,
                              "enable-hierarchy-filters": true,
                              "enable-store-group-chain-filter": false,
                              "enable-client-product-key-filter": false,
                              "hierarchy-filter-level":
                                _vm.hierarchyFilterLevel,
                              "title-localisation":
                                "settings.penaltyRules.scope.scopeApplied",
                              "filter-count-localisation":
                                "settings.penaltyRules.scope.numApplied",
                            },
                            on: { attributeFilterChange: _vm.updateRuleScope },
                          }),
                          _vm._v(" "),
                          _c(
                            VTabs,
                            {
                              staticClass: "pricing-tabs",
                              attrs: {
                                "active-class": "pricing-tabs__tab--active",
                                "background-color": "transparent",
                                color: "white",
                                height: "4rem",
                                "hide-slider": "",
                              },
                              model: {
                                value: _vm.tab,
                                callback: function ($$v) {
                                  _vm.tab = $$v
                                },
                                expression: "tab",
                              },
                            },
                            [
                              _vm._l(_vm.tabs, function (item, i) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      key: item.iconText + i,
                                      staticClass: "d-flex",
                                      attrs: {
                                        "custom-title-msg": item.tooltipMessage,
                                        "custom-title-hidden":
                                          !item.tooltipMessage,
                                        "custom-title-position": "right",
                                      },
                                    },
                                    [
                                      _c(
                                        VTab,
                                        {
                                          staticClass:
                                            "pricing-tabs__tab pricing-tabs__tab--first pr-0",
                                          on: {
                                            click: function ($event) {
                                              return _vm.tabChange(item)
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            VLayout,
                                            [
                                              _c(
                                                VLayout,
                                                {
                                                  staticClass: "pr-1",
                                                  attrs: {
                                                    "align-self-center": "",
                                                    "justify-start": "",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    VAvatar,
                                                    {
                                                      staticClass:
                                                        "traffic-light",
                                                      class: item.iconClass,
                                                      attrs: { size: "2.5rem" },
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "white--text headline",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              item.iconText
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "tab-title",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(item.tabText)
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                VLayout,
                                                {
                                                  attrs: {
                                                    "align-self-center": "",
                                                    "justify-end": "",
                                                  },
                                                },
                                                [
                                                  _vm.hasActiveExactMatch(item)
                                                    ? _c(
                                                        VIcon,
                                                        {
                                                          staticClass:
                                                            "pl-2 pr-0",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        $puzzleCheckmark\n                      "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.hasActiveMaxUpDown(item)
                                                    ? _c(
                                                        VIcon,
                                                        {
                                                          staticClass:
                                                            "pl-2 pr-0",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        mdi-arrow-up-down\n                      "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _c(VCheckbox, {
                                                    staticClass:
                                                      "activate-checkbox pl-1 pr-0",
                                                    attrs: {
                                                      "true-value": _vm.active,
                                                      "false-value":
                                                        _vm.inactive,
                                                      disabled:
                                                        _vm.isTabDisabled(item),
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        return _vm.setStatus(
                                                          item
                                                        )
                                                      },
                                                    },
                                                    model: {
                                                      value: item.status,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          item,
                                                          "status",
                                                          $$v
                                                        )
                                                      },
                                                      expression: "item.status",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              }),
                              _vm._v(" "),
                              _c("div", {
                                staticClass: "pricing-tabs__filler",
                              }),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            VTabsItems,
                            {
                              model: {
                                value: _vm.tab,
                                callback: function ($$v) {
                                  _vm.tab = $$v
                                },
                                expression: "tab",
                              },
                            },
                            _vm._l(_vm.tabs, function (item, i) {
                              return _c(
                                VTabItem,
                                {
                                  key: item.iconText + i,
                                  staticClass: "tab-content",
                                  class: { opaque: item.disabled },
                                },
                                [
                                  item.penalty ===
                                  _vm.penaltyCategories.competitor
                                    ? _c(
                                        VContainer,
                                        { attrs: { fluid: "" } },
                                        [
                                          _c(
                                            VRow,
                                            [
                                              _vm.isFixedCompetitorPenaltyWeightEnabled(
                                                item
                                              )
                                                ? _c(
                                                    VCol,
                                                    { attrs: { cols: "3" } },
                                                    [
                                                      _c(VSwitch, {
                                                        attrs: {
                                                          label: _vm.$t(
                                                            "settings.penaltyRules.enableFixedCompetitorPenaltyWeight"
                                                          ),
                                                          primary: "",
                                                          dense: "",
                                                          "hide-details": "",
                                                        },
                                                        on: {
                                                          change:
                                                            _vm.toggleFixedCompetitorPenaltyWeight,
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.mutableRule
                                                              .competitorPenalty
                                                              .weighted,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.mutableRule
                                                                .competitorPenalty,
                                                              "weighted",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "mutableRule.competitorPenalty.weighted",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c(
                                                VCol,
                                                {
                                                  staticClass: "d-flex",
                                                  attrs: { cols: "9" },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "field-heading pr-3 pt-2",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "settings.penaltyRules.competitorSelectText"
                                                            )
                                                          ) +
                                                          ":\n                    "
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    { staticClass: "pr-2" },
                                                    [
                                                      _c(VSelect, {
                                                        staticClass:
                                                          "pa-0 ma-0",
                                                        attrs: {
                                                          items:
                                                            _vm.competitorDropdownValues,
                                                        },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "item",
                                                              fn: function (
                                                                props
                                                              ) {
                                                                return [
                                                                  _c(
                                                                    VLayout,
                                                                    [
                                                                      _c(
                                                                        VLayout,
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              "align-self-center":
                                                                                "",
                                                                              "justify-start":
                                                                                "",
                                                                            },
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "item-text",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  props
                                                                                    .item
                                                                                    .text
                                                                                )
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        VLayout,
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              "align-self-center":
                                                                                "",
                                                                              "justify-end":
                                                                                "",
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm.isCompetitorActive(
                                                                            props
                                                                              .item
                                                                              .value
                                                                          )
                                                                            ? _c(
                                                                                VIcon,
                                                                                {
                                                                                  attrs:
                                                                                    {
                                                                                      right:
                                                                                        "",
                                                                                    },
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "\n                                done\n                              "
                                                                                  ),
                                                                                ]
                                                                              )
                                                                            : _vm._e(),
                                                                        ],
                                                                        1
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                ]
                                                              },
                                                            },
                                                          ],
                                                          null,
                                                          true
                                                        ),
                                                        model: {
                                                          value:
                                                            _vm.selectedCompetitorIndex,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.selectedCompetitorIndex =
                                                              $$v
                                                          },
                                                          expression:
                                                            "selectedCompetitorIndex",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    [
                                                      _c(VCheckbox, {
                                                        staticClass:
                                                          "pa-0 ma-0",
                                                        attrs: {
                                                          label: _vm.$t(
                                                            "settings.penaltyRules.active"
                                                          ),
                                                          disabled:
                                                            _vm.isTabDisabled(
                                                              item
                                                            ),
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.onCompetitorActiveToggle(
                                                              item
                                                            )
                                                          },
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.competitorIsActive,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.competitorIsActive =
                                                              $$v
                                                          },
                                                          expression:
                                                            "competitorIsActive",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    [
                                                      _vm.displayCompetitorExactMatch
                                                        ? _c(VCheckbox, {
                                                            staticClass:
                                                              "pl-5 pt-0 pr-0 pb-0 ma-0",
                                                            attrs: {
                                                              label: _vm.$t(
                                                                "settings.penaltyRules.exactMatch"
                                                              ),
                                                              disabled:
                                                                _vm.isTabDisabled(
                                                                  item
                                                                ),
                                                            },
                                                            on: {
                                                              change:
                                                                _vm.toggleCompetitorExactMatch,
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.competitorIsExactMatch,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.competitorIsExactMatch =
                                                                    $$v
                                                                },
                                                              expression:
                                                                "competitorIsExactMatch",
                                                            },
                                                          })
                                                        : _vm._e(),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.penalty ===
                                  _vm.penaltyCategories.maxUpDown
                                    ? _c(
                                        VContainer,
                                        { attrs: { fluid: "" } },
                                        [
                                          _c(
                                            VRow,
                                            {
                                              staticClass: "mud-row",
                                              attrs: {
                                                align: "center",
                                                "no-gutters": "",
                                              },
                                            },
                                            [
                                              _c(
                                                VCol,
                                                {
                                                  staticClass:
                                                    "mud-input d-flex align-center",
                                                  attrs: {
                                                    cols: "12",
                                                    md: "auto",
                                                  },
                                                },
                                                [
                                                  _c(VTextField, {
                                                    staticClass:
                                                      "max-up-down-input",
                                                    attrs: {
                                                      flat: "",
                                                      "background-color":
                                                        _vm.owWhite,
                                                      label: _vm.$t(
                                                        "settings.penaltyRules.maxUpPct"
                                                      ),
                                                      type: "number",
                                                      step: "1",
                                                      inputmode: "decimal",
                                                      rules: [
                                                        _vm.rules
                                                          .valueIsPositiveOrZero,
                                                      ],
                                                      disabled:
                                                        _vm.isTabDisabled(
                                                          item
                                                        ) || !_vm.applyMaxUp,
                                                      suffix: "%",
                                                    },
                                                    model: {
                                                      value: _vm.maxUpPctUi,
                                                      callback: function ($$v) {
                                                        _vm.maxUpPctUi =
                                                          _vm._n($$v)
                                                      },
                                                      expression: "maxUpPctUi",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                VCol,
                                                {
                                                  staticClass:
                                                    "mud-control d-flex align-center",
                                                  attrs: {
                                                    cols: "12",
                                                    md: "auto",
                                                  },
                                                },
                                                [
                                                  _c(VCheckbox, {
                                                    staticClass: "pa-0 ma-0",
                                                    attrs: {
                                                      label: _vm.$t(
                                                        "settings.penaltyRules.Active"
                                                      ),
                                                      disabled:
                                                        _vm.isTabDisabled(item),
                                                    },
                                                    model: {
                                                      value: _vm.applyMaxUp,
                                                      callback: function ($$v) {
                                                        _vm.applyMaxUp = $$v
                                                      },
                                                      expression: "applyMaxUp",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            VRow,
                                            {
                                              staticClass: "mud-row",
                                              attrs: {
                                                align: "center",
                                                "no-gutters": "",
                                              },
                                            },
                                            [
                                              _c(
                                                VCol,
                                                {
                                                  staticClass:
                                                    "mud-input d-flex align-center",
                                                  attrs: {
                                                    cols: "12",
                                                    md: "auto",
                                                  },
                                                },
                                                [
                                                  _c(VTextField, {
                                                    staticClass:
                                                      "max-up-down-input",
                                                    attrs: {
                                                      flat: "",
                                                      "background-color":
                                                        _vm.owWhite,
                                                      label: _vm.$t(
                                                        "settings.penaltyRules.maxDownPct"
                                                      ),
                                                      type: "number",
                                                      step: "1",
                                                      inputmode: "decimal",
                                                      rules: [
                                                        _vm.rules
                                                          .valueIsPositiveOrZero,
                                                      ],
                                                      disabled:
                                                        _vm.isTabDisabled(
                                                          item
                                                        ) || !_vm.applyMaxDown,
                                                      suffix: "%",
                                                    },
                                                    model: {
                                                      value: _vm.maxDownPctUi,
                                                      callback: function ($$v) {
                                                        _vm.maxDownPctUi =
                                                          _vm._n($$v)
                                                      },
                                                      expression:
                                                        "maxDownPctUi",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                VCol,
                                                {
                                                  staticClass:
                                                    "mud-control d-flex align-center",
                                                  attrs: {
                                                    cols: "12",
                                                    md: "auto",
                                                  },
                                                },
                                                [
                                                  _c(VCheckbox, {
                                                    staticClass: "pa-0 ma-0",
                                                    attrs: {
                                                      label: _vm.$t(
                                                        "settings.penaltyRules.Active"
                                                      ),
                                                      disabled:
                                                        _vm.isTabDisabled(item),
                                                    },
                                                    model: {
                                                      value: _vm.applyMaxDown,
                                                      callback: function ($$v) {
                                                        _vm.applyMaxDown = $$v
                                                      },
                                                      expression:
                                                        "applyMaxDown",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("store-group-penalty-tab", {
                                    attrs: {
                                      item: item,
                                      "mutable-rule": _vm.mutableRule,
                                      disabled: _vm.disabled,
                                      "store-group-dropdown-values":
                                        _vm.storeGroupDropdownValues,
                                      "selected-store-group-index":
                                        _vm.selectedStoreGroupIndex,
                                    },
                                    on: {
                                      "update:selectedStoreGroupIndex":
                                        function ($event) {
                                          _vm.selectedStoreGroupIndex = $event
                                        },
                                    },
                                  }),
                                  _vm._v(" "),
                                  item.penalty === _vm.penaltyCategories.minMax
                                    ? _c(
                                        VContainer,
                                        { attrs: { fluid: "" } },
                                        [
                                          _c(VRow, [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "field-heading pr-3 pt-2",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "settings.penaltyRules.storeGroupSelectText"
                                                      )
                                                    ) +
                                                    ":\n                  "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "pr-2" },
                                              [
                                                _c(VSelect, {
                                                  staticClass: "pa-0 ma-0",
                                                  attrs: {
                                                    items:
                                                      _vm.allStoreGroupDropdownValues,
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "item",
                                                        fn: function (props) {
                                                          return [
                                                            _c(
                                                              VLayout,
                                                              [
                                                                _c(
                                                                  VLayout,
                                                                  {
                                                                    attrs: {
                                                                      "align-self-center":
                                                                        "",
                                                                      "justify-start":
                                                                        "",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "item-text",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            props
                                                                              .item
                                                                              .text
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  VLayout,
                                                                  {
                                                                    attrs: {
                                                                      "align-self-center":
                                                                        "",
                                                                      "justify-end":
                                                                        "",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm.isMinMaxStoreGroupActive(
                                                                      props.item
                                                                        .value
                                                                    )
                                                                      ? _c(
                                                                          VIcon,
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                right:
                                                                                  "",
                                                                              },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "\n                              done\n                            "
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                  ],
                                                                  1
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                  model: {
                                                    value:
                                                      _vm.selectedMinMaxStoreGroupIndex,
                                                    callback: function ($$v) {
                                                      _vm.selectedMinMaxStoreGroupIndex =
                                                        $$v
                                                    },
                                                    expression:
                                                      "selectedMinMaxStoreGroupIndex",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              [
                                                _c(VCheckbox, {
                                                  staticClass: "pa-0 ma-0",
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "settings.penaltyRules.active"
                                                    ),
                                                    disabled:
                                                      _vm.isTabDisabled(item),
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.minMaxStoreGroupIsActive,
                                                    callback: function ($$v) {
                                                      _vm.minMaxStoreGroupIsActive =
                                                        $$v
                                                    },
                                                    expression:
                                                      "minMaxStoreGroupIsActive",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.penalty ===
                                  _vm.penaltyCategories.pricePointing
                                    ? _c(
                                        VContainer,
                                        { attrs: { fluid: "" } },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "d-flex flex-column",
                                            },
                                            [
                                              _vm.duplicateRangeMaximumsInPricePointing
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "validation-fail pl-2",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "settings.penaltyRules.pricePointing.pricePointingRangeMaximumValidationError"
                                                            )
                                                          ) +
                                                          "\n                  "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.missingEmptyPricePointingRange
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "validation-fail pl-2",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "settings.penaltyRules.pricePointing.pricePointingMissingMaxRange"
                                                            )
                                                          ) +
                                                          "\n                  "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.missingTokensForPricePointingRange
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "validation-fail pl-2",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "settings.penaltyRules.pricePointing.pricePointingMissingOffsets"
                                                            )
                                                          ) +
                                                          "\n                  "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm._l(
                                            item.rule.allowedValues,
                                            function (allowedValue, index) {
                                              return _c("price-pointing", {
                                                key: index,
                                                attrs: {
                                                  "price-pointing":
                                                    allowedValue,
                                                  "index-in-array": index,
                                                  disabled:
                                                    _vm.isTabDisabled(item),
                                                },
                                                on: {
                                                  deletePricePointing:
                                                    _vm.deletePricePointing,
                                                  updateRangeMaximum:
                                                    _vm.updateRangeMaximum,
                                                  updateOffset:
                                                    _vm.updateOffset,
                                                  updateBase: _vm.updateBase,
                                                },
                                              })
                                            }
                                          ),
                                          _vm._v(" "),
                                          !_vm.disabled
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "add-pricepointing-container pl-2",
                                                },
                                                [
                                                  _c(
                                                    VIcon,
                                                    {
                                                      staticClass:
                                                        "add-pricepointing-icon",
                                                      attrs: { small: "" },
                                                      on: {
                                                        click:
                                                          _vm.startPricePointingCreation,
                                                      },
                                                    },
                                                    [_vm._v("fa-plus-square")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "add-pricepointing-text",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "settings.penaltyRules.pricePointing.addRangeBreak"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                        ],
                                        2
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.penalty !==
                                    _vm.penaltyCategories.pricePointing &&
                                  item.penalty !==
                                    _vm.penaltyCategories.maxUpDown
                                    ? _c(
                                        VLayout,
                                        [
                                          _vm.isFixedCompetitorPenaltyWeightEnabled(
                                            item
                                          )
                                            ? _c(
                                                VFlex,
                                                { attrs: { xs3: "" } },
                                                [
                                                  _c(
                                                    VForm,
                                                    {
                                                      ref: "fixedPenaltyForm",
                                                      refInFor: true,
                                                      staticClass:
                                                        "fixed-competitor__form mr-5 pa-4 pt-2",
                                                      class: {
                                                        opaque:
                                                          !_vm.mutableRule
                                                            .competitorPenalty
                                                            .weighted,
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.isFixedPenaltyFormValid,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.isFixedPenaltyFormValid =
                                                            $$v
                                                        },
                                                        expression:
                                                          "isFixedPenaltyFormValid",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        VRow,
                                                        [
                                                          _c(
                                                            VCol,
                                                            {
                                                              staticClass:
                                                                "font-weight-bold",
                                                              class: {
                                                                "disabled-text":
                                                                  !_vm
                                                                    .mutableRule
                                                                    .competitorPenalty
                                                                    .weighted,
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                        " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "settings.penaltyRules.totalWeightCompetitorEngine"
                                                                    )
                                                                  ) +
                                                                  "\n                      "
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "table",
                                                        {
                                                          staticClass:
                                                            "fixed-competitor__penalty-table fixed-competitor__penalty-table--narrow",
                                                        },
                                                        [
                                                          _c("thead", [
                                                            _c("tr", [
                                                              _c("th", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "settings.penaltyRules.sideOfRefPrice"
                                                                    )
                                                                  )
                                                                ),
                                                              ]),
                                                              _vm._v(" "),
                                                              _c("th", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "settings.penaltyRules.maxPenalty"
                                                                    )
                                                                  )
                                                                ),
                                                              ]),
                                                            ]),
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("tbody", [
                                                            _c("tr", [
                                                              _c("td", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "settings.penaltyRules.lower"
                                                                    )
                                                                  )
                                                                ),
                                                              ]),
                                                              _vm._v(" "),
                                                              _c(
                                                                "td",
                                                                [
                                                                  _c(
                                                                    VTextField,
                                                                    {
                                                                      staticClass:
                                                                        "mt-0 pt-0",
                                                                      attrs: {
                                                                        flat: "",
                                                                        reverse:
                                                                          "",
                                                                        "hide-details":
                                                                          "",
                                                                        type: "number",
                                                                        min: "0",
                                                                        rules: [
                                                                          _vm
                                                                            .rules
                                                                            .required,
                                                                          _vm
                                                                            .rules
                                                                            .valueIsPositiveOrZero,
                                                                        ],
                                                                        "background-color":
                                                                          _vm.owWhite,
                                                                        disabled:
                                                                          !_vm
                                                                            .mutableRule
                                                                            .competitorPenalty
                                                                            .weighted,
                                                                      },
                                                                      on: {
                                                                        input:
                                                                          _vm.updateA2D2points,
                                                                      },
                                                                      model: {
                                                                        value:
                                                                          _vm.maxPenaltyBelow,
                                                                        callback:
                                                                          function (
                                                                            $$v
                                                                          ) {
                                                                            _vm.maxPenaltyBelow =
                                                                              _vm._n(
                                                                                $$v
                                                                              )
                                                                          },
                                                                        expression:
                                                                          "maxPenaltyBelow",
                                                                      },
                                                                    }
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ]),
                                                            _vm._v(" "),
                                                            _c("tr", [
                                                              _c("td", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "settings.penaltyRules.upper"
                                                                    )
                                                                  )
                                                                ),
                                                              ]),
                                                              _vm._v(" "),
                                                              _c(
                                                                "td",
                                                                [
                                                                  _c(
                                                                    VTextField,
                                                                    {
                                                                      staticClass:
                                                                        "mt-0 pt-0",
                                                                      attrs: {
                                                                        flat: "",
                                                                        reverse:
                                                                          "",
                                                                        "hide-details":
                                                                          "",
                                                                        type: "number",
                                                                        min: "0",
                                                                        rules: [
                                                                          _vm
                                                                            .rules
                                                                            .required,
                                                                          _vm
                                                                            .rules
                                                                            .valueIsPositiveOrZero,
                                                                        ],
                                                                        "background-color":
                                                                          _vm.owWhite,
                                                                        disabled:
                                                                          !_vm
                                                                            .mutableRule
                                                                            .competitorPenalty
                                                                            .weighted,
                                                                      },
                                                                      on: {
                                                                        input:
                                                                          _vm.updateA2D2points,
                                                                      },
                                                                      model: {
                                                                        value:
                                                                          _vm.maxPenaltyAbove,
                                                                        callback:
                                                                          function (
                                                                            $$v
                                                                          ) {
                                                                            _vm.maxPenaltyAbove =
                                                                              _vm._n(
                                                                                $$v
                                                                              )
                                                                          },
                                                                        expression:
                                                                          "maxPenaltyAbove",
                                                                      },
                                                                    }
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ]),
                                                          ]),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        VRow,
                                                        { staticClass: "mt-3" },
                                                        [
                                                          _c(
                                                            VCol,
                                                            {
                                                              staticClass:
                                                                "font-weight-bold",
                                                              class: {
                                                                "disabled-text":
                                                                  !_vm
                                                                    .mutableRule
                                                                    .competitorPenalty
                                                                    .weighted,
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                        " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "settings.penaltyRules.distributionOfWeights"
                                                                    )
                                                                  ) +
                                                                  "\n                      "
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "fixed-competitor__penalty-table-container",
                                                        },
                                                        [
                                                          _c(
                                                            "table",
                                                            {
                                                              staticClass:
                                                                "fixed-competitor__penalty-table",
                                                            },
                                                            [
                                                              _c("thead", [
                                                                _c("tr", [
                                                                  _c("th", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "settings.penaltyRules.competitor"
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]),
                                                                  _vm._v(" "),
                                                                  _c("th", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "settings.penaltyRules.weightBelow"
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]),
                                                                  _vm._v(" "),
                                                                  _c("th", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "settings.penaltyRules.weightAbove"
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]),
                                                                ]),
                                                              ]),
                                                              _vm._v(" "),
                                                              _c(
                                                                "tbody",
                                                                [
                                                                  _vm._l(
                                                                    _vm.activeCompetitorsPenalties,
                                                                    function (
                                                                      competitor
                                                                    ) {
                                                                      return _c(
                                                                        "tr",
                                                                        {
                                                                          key: competitor.competitorKey,
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "td",
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  competitor.competitorName
                                                                                )
                                                                              ),
                                                                            ]
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "td",
                                                                            {
                                                                              staticClass:
                                                                                "input-column",
                                                                            },
                                                                            [
                                                                              _c(
                                                                                VTextField,
                                                                                {
                                                                                  staticClass:
                                                                                    "mt-0 pt-0",
                                                                                  attrs:
                                                                                    {
                                                                                      flat: "",
                                                                                      reverse:
                                                                                        "",
                                                                                      "hide-details":
                                                                                        "",
                                                                                      type: "number",
                                                                                      min: "0",
                                                                                      value:
                                                                                        _vm.get(
                                                                                          _vm.mutableRule,
                                                                                          `competitorPenalty.weights.below[${competitor.competitorName}]`
                                                                                        ),
                                                                                      rules:
                                                                                        [
                                                                                          _vm
                                                                                            .rules
                                                                                            .required,
                                                                                          _vm
                                                                                            .rules
                                                                                            .valueIsPositiveOrZero,
                                                                                        ],
                                                                                      "background-color":
                                                                                        _vm.owWhite,
                                                                                      disabled:
                                                                                        !_vm
                                                                                          .mutableRule
                                                                                          .competitorPenalty
                                                                                          .weighted,
                                                                                    },
                                                                                  on: {
                                                                                    input:
                                                                                      (
                                                                                        value
                                                                                      ) =>
                                                                                        _vm.onWeightInput(
                                                                                          {
                                                                                            value,
                                                                                            competitor,
                                                                                            type: "below",
                                                                                          }
                                                                                        ),
                                                                                  },
                                                                                }
                                                                              ),
                                                                            ],
                                                                            1
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "td",
                                                                            {
                                                                              staticClass:
                                                                                "input-column",
                                                                            },
                                                                            [
                                                                              _c(
                                                                                VTextField,
                                                                                {
                                                                                  staticClass:
                                                                                    "mt-0 pt-0",
                                                                                  attrs:
                                                                                    {
                                                                                      flat: "",
                                                                                      reverse:
                                                                                        "",
                                                                                      "hide-details":
                                                                                        "",
                                                                                      type: "number",
                                                                                      min: "0",
                                                                                      value:
                                                                                        _vm.get(
                                                                                          _vm.mutableRule,
                                                                                          `competitorPenalty.weights.above[${competitor.competitorName}]`
                                                                                        ),
                                                                                      rules:
                                                                                        [
                                                                                          _vm
                                                                                            .rules
                                                                                            .required,
                                                                                          _vm
                                                                                            .rules
                                                                                            .valueIsPositiveOrZero,
                                                                                        ],
                                                                                      "background-color":
                                                                                        _vm.owWhite,
                                                                                      disabled:
                                                                                        !_vm
                                                                                          .mutableRule
                                                                                          .competitorPenalty
                                                                                          .weighted,
                                                                                    },
                                                                                  on: {
                                                                                    input:
                                                                                      (
                                                                                        value
                                                                                      ) =>
                                                                                        _vm.onWeightInput(
                                                                                          {
                                                                                            value,
                                                                                            competitor,
                                                                                            type: "above",
                                                                                          }
                                                                                        ),
                                                                                  },
                                                                                }
                                                                              ),
                                                                            ],
                                                                            1
                                                                          ),
                                                                        ]
                                                                      )
                                                                    }
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "tr",
                                                                    {
                                                                      staticClass:
                                                                        "text-right font-weight-bold",
                                                                    },
                                                                    [
                                                                      _c("td", [
                                                                        _vm._v(
                                                                          "\n                              " +
                                                                            _vm._s(
                                                                              _vm.$t(
                                                                                "settings.penaltyRules.total"
                                                                              )
                                                                            ) +
                                                                            "\n                            "
                                                                        ),
                                                                      ]),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "td",
                                                                        {
                                                                          staticClass:
                                                                            "input-column",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "\n                              " +
                                                                              _vm._s(
                                                                                _vm.getWeightsSum(
                                                                                  "below"
                                                                                )
                                                                              ) +
                                                                              "\n                            "
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "td",
                                                                        {
                                                                          staticClass:
                                                                            "input-column",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "\n                              " +
                                                                              _vm._s(
                                                                                _vm.getWeightsSum(
                                                                                  "above"
                                                                                )
                                                                              ) +
                                                                              "\n                            "
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ],
                                                                2
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            VFlex,
                                            _vm._b(
                                              {},
                                              "v-flex",
                                              {
                                                xs9: _vm.isFixedCompetitorPenaltyWeightEnabled(
                                                  item
                                                ),
                                                xs12: !_vm.isFixedCompetitorPenaltyWeightEnabled(
                                                  item
                                                ),
                                              },
                                              false
                                            ),
                                            [
                                              _c(
                                                VLayout,
                                                [
                                                  _c(
                                                    "form",
                                                    {
                                                      class: {
                                                        formWrapper: !(
                                                          item.penalty ===
                                                            _vm
                                                              .penaltyCategories
                                                              .storeGroup &&
                                                          _vm.isStoreGroupMaxUpDownEnabled
                                                        ),
                                                        "formWrapper--weighted":
                                                          _vm.isWeightedRule(
                                                            item
                                                          ),
                                                        "panels-form":
                                                          item.penalty ===
                                                            _vm
                                                              .penaltyCategories
                                                              .storeGroup &&
                                                          _vm.isStoreGroupMaxUpDownEnabled,
                                                      },
                                                      attrs: { novalidate: "" },
                                                    },
                                                    [
                                                      _c(
                                                        VFlex,
                                                        {
                                                          class: {
                                                            "panels-stretch":
                                                              item.penalty ===
                                                                _vm
                                                                  .penaltyCategories
                                                                  .storeGroup &&
                                                              _vm.isStoreGroupMaxUpDownEnabled,
                                                          },
                                                          attrs: { xs8: "" },
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "d-flex",
                                                              class: {
                                                                "panels-row":
                                                                  item.penalty ===
                                                                    _vm
                                                                      .penaltyCategories
                                                                      .storeGroup &&
                                                                  _vm.isStoreGroupMaxUpDownEnabled,
                                                              },
                                                            },
                                                            [
                                                              item.penalty ===
                                                                _vm
                                                                  .penaltyCategories
                                                                  .storeGroup &&
                                                              _vm.isStoreGroupMaxUpDownEnabled
                                                                ? _c(
                                                                    "store-group-max-up-down-panel",
                                                                    {
                                                                      attrs: {
                                                                        "selected-store-group-penalty":
                                                                          _vm.selectedStoreGroupPenalty,
                                                                      },
                                                                      on: {
                                                                        validationChange:
                                                                          _vm.onStoreGroupMaxUpDownValidationChange,
                                                                      },
                                                                    }
                                                                  )
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              _c(
                                                                "div",
                                                                {
                                                                  class: {
                                                                    "store-group-offsets-panel":
                                                                      item.penalty ===
                                                                        _vm
                                                                          .penaltyCategories
                                                                          .storeGroup &&
                                                                      _vm.isStoreGroupMaxUpDownEnabled,
                                                                    "offset-panel-box":
                                                                      item.penalty ===
                                                                        _vm
                                                                          .penaltyCategories
                                                                          .storeGroup &&
                                                                      _vm.isStoreGroupMaxUpDownEnabled,
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    VLayout,
                                                                    {
                                                                      class: {
                                                                        opaque:
                                                                          _vm.isExactMatchDisablingOffsets(
                                                                            item
                                                                          ),
                                                                      },
                                                                      attrs: {
                                                                        "align-baseline":
                                                                          "",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        VTextField,
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              flat: "",
                                                                              "background-color":
                                                                                _vm.owWhite,
                                                                              label:
                                                                                _vm.$t(
                                                                                  "settings.penaltyRules.offset"
                                                                                ),
                                                                              type: "number",
                                                                              value:
                                                                                _vm.getPenaltyRuleFromItem(
                                                                                  item
                                                                                )
                                                                                  .penaltyOffset,
                                                                              rules:
                                                                                _vm
                                                                                  .rules
                                                                                  .offsetInput,
                                                                              disabled:
                                                                                _vm.isTabDisabled(
                                                                                  item
                                                                                ) ||
                                                                                _vm.isExactMatchDisablingOffsets(
                                                                                  item
                                                                                ),
                                                                            },
                                                                          on: {
                                                                            input:
                                                                              (
                                                                                value
                                                                              ) =>
                                                                                _vm.debounceOffsetChange(
                                                                                  item,
                                                                                  value
                                                                                ),
                                                                          },
                                                                        }
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "suffix",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " % "
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                  _vm._v(" "),
                                                                  [
                                                                    _vm
                                                                      .penaltyCategories
                                                                      .competitor,
                                                                    _vm
                                                                      .penaltyCategories
                                                                      .minMax,
                                                                    _vm
                                                                      .penaltyCategories
                                                                      .storeGroup,
                                                                  ].includes(
                                                                    item.penalty
                                                                  )
                                                                    ? _c(
                                                                        VLayout,
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              "align-baseline":
                                                                                "",
                                                                            },
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "prefix",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "\n                                " +
                                                                                  _vm._s(
                                                                                    _vm.$t(
                                                                                      "clientCurrencySymbol"
                                                                                    )
                                                                                  ) +
                                                                                  "\n                              "
                                                                              ),
                                                                            ]
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            VTextField,
                                                                            {
                                                                              attrs:
                                                                                {
                                                                                  value:
                                                                                    _vm.formatNumber(
                                                                                      {
                                                                                        number:
                                                                                          _vm.getPenaltyRuleFromItem(
                                                                                            item
                                                                                          )
                                                                                            .absoluteOffset ||
                                                                                          0,
                                                                                        format:
                                                                                          _vm
                                                                                            .numberFormats
                                                                                            .priceFormatNegative,
                                                                                      }
                                                                                    ),
                                                                                  type: "text",
                                                                                  "background-color":
                                                                                    _vm.owWhite,
                                                                                  label:
                                                                                    _vm.$t(
                                                                                      "settings.penaltyRules.absoluteOffset"
                                                                                    ),
                                                                                  disabled:
                                                                                    _vm.isTabDisabled(
                                                                                      item
                                                                                    ) ||
                                                                                    _vm.isExactMatchDisablingOffsets(
                                                                                      item
                                                                                    ),
                                                                                },
                                                                              on: {
                                                                                keypress:
                                                                                  function (
                                                                                    $event
                                                                                  ) {
                                                                                    return _vm.ensureDecimal(
                                                                                      $event,
                                                                                      true
                                                                                    )
                                                                                  },
                                                                                focus:
                                                                                  function (
                                                                                    $event
                                                                                  ) {
                                                                                    _vm.previousFieldValue =
                                                                                      $event.target.value
                                                                                  },
                                                                                blur: _vm.verifyFieldValue,
                                                                                change:
                                                                                  function (
                                                                                    $event
                                                                                  ) {
                                                                                    return _vm.absoluteOffsetChange(
                                                                                      $event,
                                                                                      item
                                                                                    )
                                                                                  },
                                                                              },
                                                                            }
                                                                          ),
                                                                        ],
                                                                        1
                                                                      )
                                                                    : _vm._e(),
                                                                ],
                                                                1
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    VFlex,
                                                    _vm._b(
                                                      {
                                                        staticClass:
                                                          "chart-container",
                                                        class: {
                                                          opaque:
                                                            _vm.shouldDisableChartAndParameters(
                                                              item
                                                            ),
                                                        },
                                                        attrs: {
                                                          layout: "",
                                                          "pt-8": "",
                                                        },
                                                      },
                                                      "v-flex",
                                                      {
                                                        xs5: _vm.isFixedCompetitorPenaltyWeightEnabled(
                                                          item
                                                        ),
                                                        xs6: !_vm.isFixedCompetitorPenaltyWeightEnabled(
                                                          item
                                                        ),
                                                      },
                                                      false
                                                    ),
                                                    [
                                                      _c("penalty-chart", {
                                                        key: _vm.forceRefresh[
                                                          item.penalty
                                                        ],
                                                        attrs: {
                                                          "penalty-category":
                                                            item.penalty,
                                                          "penalty-curve-points":
                                                            _vm.getPenaltyRuleFromItem(
                                                              item
                                                            ),
                                                          "is-weighted":
                                                            _vm.isWeightedRule(
                                                              item
                                                            ),
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    VFlex,
                                                    _vm._b(
                                                      {
                                                        class: {
                                                          opaque:
                                                            _vm.shouldDisableChartAndParameters(
                                                              item
                                                            ),
                                                        },
                                                        attrs: { layout: "" },
                                                      },
                                                      "v-flex",
                                                      {
                                                        xs5: _vm.isFixedCompetitorPenaltyWeightEnabled(
                                                          item
                                                        ),
                                                        xs4: !_vm.isFixedCompetitorPenaltyWeightEnabled(
                                                          item
                                                        ),
                                                      },
                                                      false
                                                    ),
                                                    [
                                                      _c(
                                                        VLayout,
                                                        {
                                                          attrs: {
                                                            "justify-space-between":
                                                              "",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "formWrapper mr-3",
                                                              class: {
                                                                "formWrapper--weighted":
                                                                  _vm.isWeightedRule(
                                                                    item
                                                                  ),
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "penalty-parameters-form",
                                                                {
                                                                  staticClass:
                                                                    "penalty-form",
                                                                  attrs: {
                                                                    "penalty-name":
                                                                      "lower",
                                                                    "penalty-rule":
                                                                      _vm.getPenaltyParameters(
                                                                        item,
                                                                        "lower"
                                                                      ),
                                                                    disabled:
                                                                      _vm.isTabDisabled(
                                                                        item
                                                                      ) ||
                                                                      _vm.shouldDisableChartAndParameters(
                                                                        item
                                                                      ),
                                                                    "is-weighted":
                                                                      _vm.isWeightedRule(
                                                                        item
                                                                      ),
                                                                  },
                                                                  on: {
                                                                    updatePenaltyRule:
                                                                      (event) =>
                                                                        _vm.updatePenaltyRuleHandler(
                                                                          item,
                                                                          event
                                                                        ),
                                                                    penaltyRuleInvalid:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        _vm.validRule = false
                                                                      },
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "formWrapper",
                                                              class: {
                                                                "formWrapper--weighted":
                                                                  _vm.isWeightedRule(
                                                                    item
                                                                  ),
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "penalty-parameters-form",
                                                                {
                                                                  staticClass:
                                                                    "penalty-form",
                                                                  attrs: {
                                                                    "penalty-name":
                                                                      "upper",
                                                                    "penalty-rule":
                                                                      _vm.getPenaltyParameters(
                                                                        item,
                                                                        "upper"
                                                                      ),
                                                                    "is-weighted":
                                                                      _vm.isWeightedRule(
                                                                        item
                                                                      ),
                                                                    disabled:
                                                                      _vm.isTabDisabled(
                                                                        item
                                                                      ) ||
                                                                      _vm.shouldDisableChartAndParameters(
                                                                        item
                                                                      ),
                                                                  },
                                                                  on: {
                                                                    updatePenaltyRule:
                                                                      (event) =>
                                                                        _vm.updatePenaltyRuleHandler(
                                                                          item,
                                                                          event
                                                                        ),
                                                                    penaltyRuleInvalid:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        _vm.validRule = false
                                                                      },
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            }),
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            VLayout,
                            {
                              attrs: {
                                "align-baseline": "",
                                "justify-space-between": "",
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "weighted-penalty-warning" },
                                [
                                  _vm.tab === 1 &&
                                  _vm.mutableRule.competitorPenalty.weighted
                                    ? _c("span", [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.$t(
                                                "settings.penaltyRules.fixedCompetitorWarning"
                                              )
                                            ) +
                                            "\n              "
                                        ),
                                      ])
                                    : _vm._e(),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "mr-6" },
                                [
                                  _c(
                                    VBtn,
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: !_vm.disabled,
                                          expression: "!disabled",
                                        },
                                      ],
                                      staticClass: "mt-2 mr-2",
                                      attrs: {
                                        small: "",
                                        color: "primary",
                                        outlined: "",
                                        depressed: "",
                                      },
                                      on: { click: _vm.cancel },
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.$t("actions.cancel")) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.isSomeWeightedCompetitorsInvalid
                                    ? _c(
                                        "div",
                                        { staticClass: "error-text mr-2" },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.$t(
                                                  "settings.penaltyRules.allWeightedCompetitorsInvalid"
                                                )
                                              ) +
                                              "\n              "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.moreThanOneActiveCompetitorExactMatch
                                    ? _c(
                                        "div",
                                        { staticClass: "error-text mr-2" },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.$t(
                                                  "settings.penaltyRules.exactMatchInvalid"
                                                )
                                              ) +
                                              "\n              "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    VBtn,
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: !_vm.disabled,
                                          expression: "!disabled",
                                        },
                                      ],
                                      staticClass: "mt-2 save",
                                      attrs: {
                                        color: "success",
                                        disabled: _vm.disableSaveBtn,
                                        small: "",
                                        depressed: "",
                                      },
                                      on: { click: _vm.save },
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.$t("actions.save")) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("confirm-dialog", {
        attrs: {
          "is-open": _vm.isFixedCompetitorPenaltyWeightDialogOpen,
          "ok-btn-text": _vm.$t("actions.yesProceed"),
        },
        on: {
          onOk: _vm.enableFixedCompetitorPenaltyWeight,
          onCancel: _vm.closeFixedCompetitorPenaltyWeightDialogOpen,
        },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.$t("dialogs.fixedCompetitorPenaltyWeight.header")
                    ) +
                    "\n    "
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("confirm-dialog", {
        attrs: {
          "is-open": _vm.isCompetitorExactMatchDialogOpen,
          "ok-btn-text": _vm.$t("actions.yesProceed"),
        },
        on: {
          onOk: _vm.enableCompetitorExactMatch,
          onCancel: _vm.closeCompetitorExactMatchDialog,
        },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("dialogs.exactCompetitorMatch.header")) +
                    "\n    "
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }